import React from 'react'
import { Header, Image, Modal, Grid, List } from 'semantic-ui-react'
import imageRedeProtecao from './../static/rede-protecao-1.jpg'

const ModalRedeComponent = ({ open, tecInfo, closeModal }) =>
  open && (
    <Modal open={open} closeIcon onClose={() => closeModal('modalRedes')}>
      <Modal.Header>Redes de Proteçao</Modal.Header>

      {tecInfo ? (
        <Modal.Content>
          <Modal.Description>
            <Header as="h3">Informações Técnicas</Header>
            <p>
              50 mm entre nós, fio 30 / 21 (cada fio é composto por 21 cabos de 0,30mm). Produção em forma de malhas,
              confeccionadas em monofilamentos de polietileno (torcido) de alta densidade.
            </p>
            <p>
              Especificação: Malha 5X5 Polietileno de alta densidade: 100% virgem, estabilizado contra a ação dos raios
              ultravioleta (UV).{' '}
            </p>
            <p>
              Durabilidade: Garantia de 5 anos contra defeitos de fabricação e durabilidade em condições normais de uso. A
              garantia não cobre danos causados após instalação, como cortes, queimaduras com chamas, produtos químicos, etc...
            </p>{' '}
            <p>
              Estes produtos foram testados de acordo com planos de inspeção e ensaio baseados nos testes de envelhecimento e
              resistência do Instituto Falcão Bauer conforme certificados E/ 53.172/ 97 e EE/10109/06, IPEI / FEI 770425/06 e
              SENAI / LET 211/2006.
            </p>
            <Header as="h3">Filamento:</Header>
            <Grid columns="equal" style={{ marginTop: '10px', marginBottom: '10px' }}>
              <Grid.Row>
                <Grid.Column>
                  <List size="medium" bulleted relaxed verticalAlign="middle">
                    <List.Item>
                      <List.Content style={{ marginLeft: '20px' }}>Polímero</List.Content>
                    </List.Item>

                    <List.Item>
                      <List.Content style={{ marginLeft: '20px' }}>Estabilizador</List.Content>
                    </List.Item>

                    <List.Item>
                      <List.Content style={{ marginLeft: '20px' }}>Estabilizador</List.Content>
                    </List.Item>

                    <List.Item>
                      <List.Content style={{ marginLeft: '20px' }}>Diâmetro</List.Content>
                    </List.Item>
                    <List.Item>
                      <List.Content style={{ marginLeft: '20px' }}>Alongamento</List.Content>
                    </List.Item>
                    <List.Item>
                      <List.Content style={{ marginLeft: '20px' }}>Máxima Temperatura de Uso</List.Content>
                    </List.Item>
                    <List.Item>
                      <List.Content style={{ marginLeft: '20px' }}>Estabilidade Dimensional</List.Content>
                    </List.Item>
                  </List>
                </Grid.Column>
                <Grid.Column>
                  <List size="medium" relaxed verticalAlign="middle">
                    <List.Item>
                      <List.Content style={{ marginLeft: '20px' }}>HDPE</List.Content>
                    </List.Item>

                    <List.Item>
                      <List.Content style={{ marginLeft: '20px' }}>anti - UV</List.Content>
                    </List.Item>

                    <List.Item>
                      <List.Content style={{ marginLeft: '20px' }}>antioxidante</List.Content>
                    </List.Item>

                    <List.Item>
                      <List.Content style={{ marginLeft: '20px' }}>1,8mm / fio torcido</List.Content>
                    </List.Item>
                    <List.Item>
                      <List.Content style={{ marginLeft: '20px' }}>60%</List.Content>
                    </List.Item>
                    <List.Item>
                      <List.Content style={{ marginLeft: '20px' }}>+ 60ºC / - 60ºC</List.Content>
                    </List.Item>
                    <List.Item>
                      <List.Content style={{ marginLeft: '20px' }}>± 3%</List.Content>
                    </List.Item>
                  </List>
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <Header as="h3">Resistência:</Header>
            <Grid columns="equal" style={{ marginTop: '10px', marginBottom: '10px' }}>
              <Grid.Row>
                <Grid.Column>
                  <List size="medium" bulleted relaxed verticalAlign="middle">
                    <List.Item>
                      <List.Content style={{ marginLeft: '20px' }}>Peso</List.Content>
                    </List.Item>

                    <List.Item>
                      <List.Content style={{ marginLeft: '20px' }}>Resistência a Tração Longitudinal</List.Content>
                    </List.Item>

                    <List.Item>
                      <List.Content style={{ marginLeft: '20px' }}>Resistência a Tração Transversal </List.Content>
                    </List.Item>

                    <List.Item>
                      <List.Content style={{ marginLeft: '20px' }}>Resistência da Rede</List.Content>
                    </List.Item>
                  </List>
                </Grid.Column>
                <Grid.Column>
                  <List size="medium" relaxed verticalAlign="middle">
                    <List.Item>
                      <List.Content style={{ marginLeft: '20px' }}>Entre 92,71 e 94,28g / m²</List.Content>
                    </List.Item>

                    <List.Item>
                      <List.Content style={{ marginLeft: '20px' }}>50kg / malha (média)</List.Content>
                    </List.Item>

                    <List.Item>
                      <List.Content style={{ marginLeft: '20px' }}>50kg / malha (média)</List.Content>
                    </List.Item>

                    <List.Item>
                      <List.Content style={{ marginLeft: '20px' }}>500kg / m² (*)</List.Content>
                    </List.Item>
                  </List>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Modal.Description>
        </Modal.Content>
      ) : (
        <Modal.Content image>
          <Image
            wrapped
            size="medium"
            src={imageRedeProtecao}
            style={{ maxHeight: '400px', maxWidth: '640px', margin: 'auto' }}
          />
          <Modal.Description>
            <Header>Saiba mais:</Header>
            <p>Redes de Proteção aonde você precisar, tenha segurança e comodidade!</p>
          </Modal.Description>
        </Modal.Content>
      )}
    </Modal>
  )

export default ModalRedeComponent
